/** @jsx jsx */

import { jsx, render, SelectionSet, Field, Variable, Mutation } from "graphql-jsx";
import { clients } from "utils/clients";
import { UuidScalar } from "GraphQL/Scalars";

type Option = Readonly<{
  uuid?: string;
}>;

export const DeleteRoleElementRelation = async (option: Option) => {
  const $uuid = <Variable name="uuid" scalar={<UuidScalar isNullable={true} />} value={option.uuid} />;
  const { query, variables } = render(
    <Mutation operationName="DELETE_ROLE_ELEMENT_RELATION">
      <SelectionSet
        name="deleteRole_self_relations_element_role"
        alias="deleteRoleSelfRelationsElementRole"
        argument={{
          where: {
            id: $uuid
          }
        }}
      >
        <Field name="id" />
      </SelectionSet>
    </Mutation>
  );
  type Data = Readonly<{
    deleteRoleSelfRelationsElementRole: Readonly<{
      id: string;
    }>[];
  }>;
  return await clients.role.request<Data>(query, variables);
};
